import React, { useState, useEffect } from 'react';

const PromotionalSlider = () => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const [timeLeft, setTimeLeft] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
    });

    // Auto-slide effect for left section only
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % 3);
        }, 5000);

        return () => clearInterval(interval);
    }, []);

    // Countdown timer effect for right section
    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeft(prev => {
                if (prev.seconds > 0) {
                    return { ...prev, seconds: prev.seconds - 1 };
                } else if (prev.minutes > 0) {
                    return { ...prev, minutes: prev.minutes - 1, seconds: 59 };
                } else if (prev.hours > 0) {
                    return { ...prev, hours: prev.hours - 1, minutes: 59, seconds: 59 };
                } else if (prev.days > 0) {
                    return { ...prev, days: prev.days - 1, hours: 23, minutes: 59, seconds: 59 };
                }
                return prev;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    // Initialize countdown (24 hours from now)
    useEffect(() => {
        const now = new Date();
        const endTime = new Date(now.getTime() + 24 * 60 * 60 * 1000); // 24 hours from now

        const calculateTimeLeft = () => {
            const difference = endTime - new Date();
            if (difference > 0) {
                setTimeLeft({
                    days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                    hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                    minutes: Math.floor((difference / 1000 / 60) % 60),
                    seconds: Math.floor((difference / 1000) % 60)
                });
            }
        };

        calculateTimeLeft();
    }, []);

    const slides = [
        {
            id: 1,
            title: 'Vente Maga',
            subtitle: 'Offre Spéciale',
            discount: 'Jusqu\'à 60% de réduction',
            cta: 'Achetez Maintenant',
            image: '/images/chair.png'
        },
        {
            id: 2,
            title: 'Promotion Flash',
            subtitle: 'Offre Limitée',
            discount: 'Jusqu\'à 50% de réduction',
            cta: 'Achetez Maintenant',
            image: '/images/chair2.png'
        },
        {
            id: 3,
            title: 'Soldes Exceptionnelles',
            subtitle: 'Offre Unique',
            discount: 'Jusqu\'à 70% de réduction',
            cta: 'Achetez Maintenant',
            image: '/images/chair3.png'
        }
    ];

    const goToSlide = (index) => {
        setCurrentSlide(index);
    };

    const nextSlide = () => {
        setCurrentSlide((prev) => (prev + 1) % slides.length);
    };

    const prevSlide = () => {
        setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
    };

    return (
        <div className="w-full lg:h-[440px] mb-4">
            <div className="flex flex-col lg:flex-row h-full gap-4 px-4 lg:px-0">
                {/* Left Section - Red Carousel */}
                <div className="w-full lg:w-3/5 relative overflow-hidden rounded-lg">
                    <div className="relative w-full h-full bg-red-800">
                        {/* Slide container */}
                        <div
                            className="flex transition-transform duration-500 ease-in-out h-full"
                            style={{ transform: `translateX(-${currentSlide * 100}%)` }}
                        >
                            {slides.map((slide, index) => (
                                <div key={slide.id} className="w-full flex-shrink-0 h-full">
                                    <img className='w-full h-full' src="/images/chair.png" alt="" />
                                </div>
                            ))}
                        </div>

                        {/* Navigation arrows for left section */}
                        <button
                            onClick={prevSlide}
                            className="absolute left-4 top-1/2 transform -translate-y-1/2 rounded-full p-2 hover:bg-opacity-100 transition-all"
                        >
                            <svg className="w-6 h-6 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                            </svg>
                        </button>

                        <button
                            onClick={nextSlide}
                            className="absolute right-4 top-1/2 transform -translate-y-1/2 rounded-full p-2 hover:bg-opacity-100 transition-all"
                        >
                            <svg className="w-6 h-6 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                            </svg>
                        </button>

                        {/* Pagination dots for left section */}
                        <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-2">
                            {slides.map((_, index) => (
                                <button
                                    key={index}
                                    onClick={() => goToSlide(index)}
                                    className={`w-3 h-3 rounded-full transition-all ${index === currentSlide ? 'bg-white' : 'bg-gray-400'
                                        }`}
                                />
                            ))}
                        </div>
                    </div>
                </div>

                {/* Right Section - Yellow Static with Countdown */}
                <div className="w-full lg:w-2/5 bg-[#F7CC60] rounded-lg p-8 flex flex-col justify-betwee">
                    {/* Top section */}
                    <div className="text-center">
                        {/* Title */}
                        <h2 className="text-2xl lg:text-3xl font-extrabold text-white mb-4">
                            Offres exceptionnelles du jour
                        </h2>

                        {/* Product image */}
                        <div className="flex justify-center mb-4">
                            <img className='h-44' src="/images/ecouteur.png" alt="" />
                        </div>
                    </div>

                    {/* Middle section - Countdown timer */}
                    <div className="flex justify-center gap-2 mb-6">
                        {Object.entries(timeLeft).map(([unit, value]) => (
                            <div key={unit} className="bg-white rounded-lg p-2 text-center h-[fit-content] w-[60px]">
                                <div className="text-lg font-bold text-black">
                                    {value.toString().padStart(2, '0')}
                                </div>
                                <div className="text-xs text-gray-600 capitalize">
                                    {unit === 'days' ? 'Jours' :
                                        unit === 'hours' ? 'Heures' :
                                            unit === 'minutes' ? 'Minutes' : 'Secs'}
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Bottom section - CTA Button */}
                    <div className="text-center">
                        <button className="bg-white text-black px-6 py-2 rounded-full font-medium flex items-center gap-2 hover:bg-gray-100 transition-colors mx-auto">
                            Achetez Maintenant
                            <span className='bg-orange-light rounded-full p-1 w-5 h-5 flex items-center justify-center'>
                                <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                </svg>
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PromotionalSlider; 